/**
 * Script for custom Public.com WordPress plugin
 * installed in bankrate-cms at resources/vendor/plugins/stock-charts-by-public-com
 */
document.addEventListener("DOMContentLoaded", function () {

    function activateLinks()
    {
        const links = [].slice.call(document.querySelectorAll(".link-public"));

        if ( links )
        {
            const container = document.createElement("div");

            container.classList.add("public-link-chart");
            container.innerHTML = '<span class="public-pointer"><i class="public-arrow"></i></span><div class="public-inner-chart"><iframe frameborder="0"></iframe></div>';
            document.body.appendChild(container);

            // unactivate on mouse leave
            container.addEventListener('mouseleave', function (event) {
              // if is not hovering over the link
              event.target.classList.remove("active");
            });

            links.forEach( node => {

                const instrument = node.dataset.stock.toLowerCase();
                const symbol     = instrument.replace('-crypto', '');

                // Update link
                if ( -1 !== instrument.indexOf('crypto') )
                {
                    node.href = 'https://public.com/crypto/' + symbol;
                }

                node.addEventListener("mouseover", function (event) {

                    // Calculate position
                    const rect  = event.target.getBoundingClientRect();
                    const width = rect.width / 2 + rect.left;
                    const left  = Math.min(window.innerWidth, 400) / 2;
                    const pos   = Math.max(width - left, 5);

                    // Update iframe source
                    const iframe = container.querySelector('iframe');
                    iframe.src   = ( -1 !== instrument.indexOf('crypto'))
                        ? 'https://public.com/crypto/' + symbol + '/embed'
                        : 'https://public.com/stocks/' + symbol + '/embed';

                    iframe.dataset.type = ( -1 !== instrument.indexOf('crypto'))
                        ? 'crypto'
                        : 'stock';

                    container.style.top  = (rect.bottom) + 'px';
                    container.style.left = pos + 'px';

                    // Make visible
                    container.classList.add('active');
                });

                node.addEventListener("mouseleave", function (event) {
                  // if not hovering over container
                  if (!(event.relatedTarget === container || container.contains(event.relatedTarget))) {
                    container.classList.remove("active");
                  }
                });
            });

            window.addEventListener('scroll', function(event) {
                container.classList.remove('active');
            });
        }

    }




    function wrapInstruments()
    {
        if ( 'undefined' === typeof window._instruments )
        {
            return;
        }

        const instruments = [];
        const walker = document.createTreeWalker(
            document.body,
            NodeFilter.SHOW_TEXT,
            /*{
                acceptNode: (node) => {
                    if (node.parentElement.tagName === 'A') {
                        return NodeFilter.FILTER_ACCEPT;
                    }
                    return NodeFilter.FILTER_SKIP;
                },
            },*/
            null,
            null
        );


        const isInstrument = (str) => {
            return window._instruments.includes(str.toLocaleUpperCase());
        }

        // console.log(window._instruments);
        
        while (walker.nextNode())
        {
            const node = walker.currentNode;

            if (node.nodeValue )
            {
                // Single text node with spaces
                const parts = node.nodeValue.split(' ');

                if ( parts.length > 1 )
                {
                    parts.forEach( part => {
                        if ( isInstrument(part) )
                        {
                            if (!instruments.includes(node.parentNode))
                            {
                                instruments.push({
                                    'symbol': part,
                                    'node': node.parentNode,
                                });
                            }
                        }
                    });
                }
                else if ( isInstrument(node.nodeValue) )
                {
                    if (!instruments.includes(node.parentNode))
                    {
                        instruments.push({
                            'symbol': node.nodeValue,
                            'node': node.parentNode,
                        });
                    }
                }
            }
        }

        instruments.forEach( node => {

            const a = document.createElement('a');
            a.href = 'https://public.com/stocks/' + node.symbol.replace('$', '');
            a.classList.add('link-public');
            a.innerText = node.symbol;
            a.dataset.stock = node.symbol.replace('$', '');

            node.node.innerHTML = node.node.innerHTML.replace( node.symbol, a.outerHTML );
        });
    }

    wrapInstruments();
    activateLinks();
});
